module.exports = __webpack_public_path__ + "media/images/svg/jobs/calendar-bdc512ce18ff54700bed0ef9c904b874.svg";